import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
import { people } from "../../config/imagesLink";
import PortalEmojiPicker from "../../components/PortalEmojiPicker";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import ErrorToast from "../ErrorToast";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import AddReactionSharpIcon from "@mui/icons-material/AddReactionSharp";
import { update } from "lodash";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import sanitizeHtml from "../../utility/sanitize";
const PostComment = ({
  postId,
  item,
  AllPostList,
  postList,
  setPage,
  setPostList,
  page,
  setTotalPages,
  totalPages,
  UserImage,
  updateCommentCount,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const profilPic = localStorage.getItem("profilPic") || people.DefaultProfile;

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };
    const { t } = useTranslation();

  //************************Post Comment  ************************//
  const [content, setContent] = useState("");
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([])
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [isSubmittingComment, setIsSubmittingComment] = useState(false);
  const language = localStorage.getItem("Lang");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [query, setQuery] = useState(""); // Store the full query
  const [typingTimeout, setTypingTimeout] = useState(null);
  const editorRef = useRef(null);
  const emojiAnchorRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [SearchText, setSearchText] = useState("")
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");

  //DS
  const [selectedIndex, setSelectedIndex] = useState(0);
  const suggestionListRef = useRef(null);
  const itemRefs = useRef([]);

  // const formatCommentWithDynamicValues = (comment, dynamicValues) => {
  //   let formattedComment = comment;
  //   dynamicValues?.forEach((value, index) => {
  //     const placeholder = new RegExp(`\\{${index + 1}\\}`, 'g');
  //     formattedComment = formattedComment.replace(placeholder, value);
  //   });
  //   return formattedComment;
  // };


  const extractDynamicValues = (comment, existingValues) => {
    const newDynamicValues = [];
    let modifiedComment = comment;
    // Extract all tags with symbol
    const matches = [...comment.matchAll(/([#@])(\w+)/g)];

    // Get the current max dVno
    let currentMaxDVno = existingValues.reduce(
      (max, item) => (item.dVno && Number(item.dVno) > max ? Number(item.dVno) : max),
      0
    );

    matches.forEach(match => {
      const fullMatch = match[0];
      const symbol = match[1]; // # or @
      const tag = match[2];    // word part only
      const display = tag;

      // const alreadyExists = existingValues.some(item => item.display === display);
      const type = symbol === "#" ? "Hashtag" : "UserMention";
      const alreadyExists = existingValues.concat(newDynamicValues).find(
        item => item.display === display && item.type === type
      );
      let dVno;
      if (alreadyExists) {
        dVno = alreadyExists.dVno;
      } else {
        currentMaxDVno += 1;
        dVno = currentMaxDVno;
        newDynamicValues.push({
          type,
          dVno,
          entity: display,
          display
        });
      }
      const regex = new RegExp(`\\${symbol}${tag}\\b`, "g");
      modifiedComment = modifiedComment.replace(regex, `{${dVno}}`);
      // if (!alreadyExists) {
      //   currentMaxDVno += 1;
      //   newDynamicValues.push({
      //     type: symbol === "#" ? "Hashtag" : "UserMention",
      //     dVno: currentMaxDVno,
      //     entity: "Hashtag" ? display : symbol,
      //     display: display
      //   });
      // }
    });
    const finalDynamicValues = [...existingValues, ...newDynamicValues];
    // return [...existingValues, ...newDynamicValues];
    return {
      formattedComment: modifiedComment,
      dynamicValues: finalDynamicValues
    };
  };


  const postData = async () => {
    // const finalDynamicValues = extractDynamicValues(postInputValue, postDynamicValues);
    // const { formattedComment, dynamicValues } = extractDynamicValues(postInputValue, postDynamicValues);
    if (isSubmittingComment) return;

    const formattedComment = updatePostInputValueWithDynamicValues(content, postDynamicValues);
    // const normalizedValues = normalizeDynamicValues(postDynamicValues);
    const postdatadetails = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      comment: sanitizeHtml(formattedComment),
      // dynamicValues: JSON.stringify(normalizedValues)
      dynamicValues: postDynamicValues,
            langKey: language === "en" ? "" : language,

    };
    console.log("Add Comment==>", postdatadetails)
    if (content.trim() === "") {
      setWarningToastMessage("Please Add the Comment");
      setShowWarningToast(true);
    } else {
      setIsSubmittingComment(true);
      try {
        const res = await axios.post("PostAction/CommentPost", postdatadetails);
        setToastMessage(res.data.message);
        setShowToast(true);
        setContent("");
        const responseData = res.data.responseData;
        // console.log("responseData7777777", responseData);

        const postDetailsResponse = await axios.get(
          `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
        );

        const updatedPost = postDetailsResponse.data.responseData;
        const newComment = {
          likeCount: 0,
          pstCmntId: responseData.pstCmntId,
          comment: responseData.comment,
          dynamicValues: postDynamicValues,
          useruid: responseData.useruid,
          userName: responseData.userName,
          isOwned: true,
          userAvatar: profilPic,
          creationTime: responseData.creationTime,
          commentsReplies: [],
          replyCount: 0
        };

        setPostList((prevList) =>
          prevList.map((post) =>
            post.postInfo?.postId === postId
              ? {
                ...post,
                postInfo: {
                  ...post.postInfo,
                  comments: [
                    newComment,
                    ...(Array.isArray(post.postInfo.comments)
                      ? post.postInfo.comments
                      : [])
                  ],
                  commentCount: (post.postInfo.commentCount || 0) + 1
                }
              }
              : post
          )
        );

        // AllPostList();


      } catch (error) {
        setErrorToastMessage(error.message);
        setShowErrorToast(true);
        //   console.log("ERRR",error.message);
      } finally {
        setIsSubmittingComment(false);
      }
    }
  };

  const handleKeyPress = () => {
    postData();
  };
  const handleEmojiClick = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };
  const handleEmojiClose = () => {
    setShowEmojiPicker(false);
  };
  //************************Post Comment  ************************//

  const normalizeDynamicValues = (dVals = []) =>
    dVals.map((item) => ({
      dVno: item.dVno,
      displayName: item.displayName || item.display,
      type: item.type,
      entity: item.entity || item.entityID,
    }));

  const parseComment = (apiComment, dynamicValues) => {
    const placeholderMap = {};
    dynamicValues.forEach(({ dVno, displayName, type }) => {
      placeholderMap[dVno] = type === "UserMention"
        ? `@${displayName}`
        : type === "Hashtag"
          ? `#${displayName}`
          : displayName;
    });

    let parsedText = apiComment;
    Object.keys(placeholderMap).forEach((key) => {
      parsedText = parsedText.replace(
        new RegExp(`\\{${key}\\}`, "g"),
        placeholderMap[key]
      );
    });

    return parsedText?.replace(/<[^>]*>/g, "").trim();
  };

  // Handle typing in textarea
  const handleChange = (e) => {
    const value = e.target.value;
    const caret = e.target.selectionStart;

    setContent(value);
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues?.filter(({ type, display }) => {
      const prefix = type === "UserMention" || type === "CompanyMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      return value.includes(fullMention);
    });

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1
    }));

    setPostDynamicValues(reassignedDynamicValues);

    const updatedPostInputValue = updatePostInputValueWithDynamicValues(value, reassignedDynamicValues);
    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, display, displayName }) => {
      const prefix = type === "UserMention" || type === "CompanyMention" ? "@" : "#";
      const fullMention = `${prefix}${display || displayName}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " " || e.key === "Tab") {
      setShowSuggestions(false);
    }
  };


  const handleTextChange = async (content, delta, source, editor) => {
    setContent(content);
    const cursorPosition = editor?.getSelection()?.index || 0;

    const textBeforeCursor = editor?.getText(0, cursorPosition);
    console.log("Text Before Cursor:", textBeforeCursor);

    //  Updated regex: capture '@' or '#' followed by 0+ word chars
    const match = textBeforeCursor?.match(/([@#])(\w*)$/);
    console.log("Match Found:", match);

    if (!match) {
      setShowSuggestions(false);
      return;
    }

    const triggerChar = match[1]; // '@' or '#'
    const query = match[2];       // typed word after trigger
    console.log("Detected Trigger:", triggerChar, "Query:", query);

    const type = triggerChar === '@' ? "UserMention" : "Hashtag";
    setMentionType(type);

    // ✅ Only fetch if query length > 0 (after '@' or '#')
    if (!query) {
      setShowSuggestions(false);
      return;
    }

    // ✅ Debounce fetchSuggestions
    if (typingTimeout) clearTimeout(typingTimeout);
    const newTimeout = setTimeout(() => {
      fetchSuggestions(query, type);
    }, 500);
    setTypingTimeout(newTimeout);
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(`General/MentionTagDDL?Search=${searchText}`, data);
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(`General/HashtagDDL?SearchHashtag=${searchText}`, data);
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  useEffect(() => {
    const textarea = document.getElementById("commentTextArea");
    if (textarea) {
      textarea.setSelectionRange(cursorPosition, cursorPosition);
      textarea.focus();
    }
  }, [cursorPosition]);

  const insertMention = (suggestion, userUid, entityType) => {
    const input = editorRef.current;
    if (!input) return;

    input.focus();
    const cursorPosition = input.selectionStart;
    const textBeforeCursor = input.value.slice(0, cursorPosition);
    const textAfterCursor = input.value.slice(cursorPosition);

    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const finalType = entityType ? entityType : (mentionType === "Hashtag" ? "Hashtag" : "UserMention");

    const mentionPrefix = mentionType === "Hashtag" ? "#" : "@";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    const updatedText = textBeforeCursor.slice(0, startIndex) + mentionText + textAfterCursor;

    input.value = updatedText;
    setContent(updatedText);

    const newCursorPosition = startIndex + mentionText.length;
    setTimeout(() => {
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);

    const safePostDynamicValues = Array.isArray(postDynamicValues) ? postDynamicValues : [];
    // const dVno = safePostDynamicValues.length + 1;
    const nextDv = {
      type: finalType,
      dVno: safePostDynamicValues.length + 1,
      entity: finalType === "Hashtag" ? displayName : (userUid ?? displayName),
      display: displayName,
    };
    // const updatedPostDynamicValues = [
    //   ...safePostDynamicValues,
    //   {
    //     type: mentionType === "Hashtag" 
    //       ? "Hashtag" 
    //       : mentionType === "CompanyMention" 
    //         ? "CompanyMention" 
    //         : "UserMention",
    //     dVno,
    //     entity: mentionType === "Hashtag" ? suggestion : userUid,
    //     display: displayName,
    //   },
    // ];
    // setPostDynamicValues(updatedPostDynamicValues);
    const updatedPostDynamicValues = [...safePostDynamicValues, nextDv];
    const normalized = updatedPostDynamicValues.map((x, i) => ({ ...x, dVno: i + 1 }));
    setPostDynamicValues(normalized);

    let modifiedText = updatedText;
    updatedPostDynamicValues.forEach(({ type, dVno, display }) => {
      const prefix = type === "Hashtag" ? "#" : "@";
      const fullMention = `${prefix}${display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    setPostInputValue(modifiedText.trim());
    setShowSuggestions(false);
    setSearchText("");
  };


  // const insertMention = (suggestion, userUid) => {
  //   const input = editorRef.current;  // Normal input or textarea
  //   if (!input) return;

  //   input.focus();

  //   const cursorPosition = input.selectionStart;
  //   const textBeforeCursor = input.value.slice(0, cursorPosition);
  //   const textAfterCursor = input.value.slice(cursorPosition);

  //   // Match @ or # mention before the cursor
  //   const match = textBeforeCursor.match(/[@#]\w*$/);
  //   if (!match) return;

  //   const startIndex = cursorPosition - match[0].length;
  //   const mentionPrefix = mentionType === "UserMention" ? "@" : "#";
  //   const displayName = suggestion;
  //   const mentionText = `${mentionPrefix}${displayName} `;

  //   // Insert mention at cursor position
  //   const updatedText =
  //     textBeforeCursor.slice(0, startIndex) + mentionText + textAfterCursor;

  //   input.value = updatedText;
  //   setContent(updatedText);

  //   const newCursorPosition = startIndex + mentionText.length;

  //   // Set cursor position after inserted mention
  //   setTimeout(() => {
  //     input.setSelectionRange(newCursorPosition, newCursorPosition);
  //   }, 0);

  //   // Update dynamic values
  //   const safePostDynamicValues = Array.isArray(postDynamicValues)
  //     ? postDynamicValues
  //     : [];
  //   const dVno = safePostDynamicValues.length + 1;

  //   const updatedPostDynamicValues = [
  //     ...safePostDynamicValues,
  //     {
  //       type: mentionType,
  //       dVno,
  //       entity: mentionType === "UserMention" ? userUid : suggestion,
  //       display: displayName,
  //     },
  //   ];
  //   setPostDynamicValues(updatedPostDynamicValues);

  //   // Replace @mention / #hashtag with {dVno}
  //   let modifiedText = updatedText;

  //   updatedPostDynamicValues.forEach(({ type, dVno, display }) => {
  //     const prefix = type === "UserMention" ? "@" : "#";
  //     const fullMention = `${prefix}${display}`;
  //     const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
  //     modifiedText = modifiedText.replace(regex, `{${dVno}}`);
  //   });

  //   setPostInputValue(`${modifiedText.trim()}`);
  //   setShowSuggestions(false);
  //   setSearchText('')
  // };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const handleKeyDown1 = (e) => {
    if (showSuggestions) {
      const totalItems = mentionType === "Hashtag" ? suggestions.length + 1 : suggestions.length;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev + 1) % totalItems);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev - 1 + totalItems) % totalItems);
      } else if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();

        if (mentionType === "Hashtag" && selectedIndex === 0) {
          insertMention(SearchText, null, null);
        } else {
          const itemIndex = mentionType === "Hashtag" ? selectedIndex - 1 : selectedIndex;
          const selectedItem = suggestions[itemIndex];
          if (selectedItem) {
            insertMention(
              mentionType === "UserMention" ? selectedItem?.entityName : selectedItem?.hashTag,
              mentionType === "UserMention" || selectedItem?.entityType === "CompanyMention" ? selectedItem?.userUid : null,
              selectedItem?.entityType,
            );
          }
        }

        setShowSuggestions(false);
        setSelectedIndex(0);
      } else if (e.key === "Escape") {
        setShowSuggestions(false);
      }
    }
  };

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    itemRefs.current = [];
    setSelectedIndex(0);
  }, [suggestions]);

  useEffect(() => {
    if (!showSuggestions) {
      setSelectedIndex(0);
    }
  }, [showSuggestions]);

  return (
    <>
      {/* {postList.map((item, index) => {
        return ( */}
      <div className="commentArea"
      >
        <div>
          <img
            src={profilPic}
            width={35}
            height={35}
            alt=""
            style={{ borderRadius: "50px" }}
            onError={handleProfileImageError}
          />
        </div>
        <div className="commentBox" >
          <input
           style={{
                                direction: language === "ar" ? "rtl" : "ltr",
                                textAlign: language === "ar" ? "right" : "left",  
                              }}
            className="me-2 ps-2"
            ref={editorRef}
            type="text"
            placeholder={t("Newsfeed.Write your comment")}
            // placeholder="Write your comment…"
            value={content}
            // onChange={(e) => {
            //   setContent(e.target.value);
            // }}
            onChange={handleChange}
            onKeyDown={handleKeyDown1}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleKeyPress();
              }
            }}
          />
          {showSuggestions && (
            <ul
              ref={suggestionListRef}
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                // backgroundColor: "#fff",
                border: "1px solid #ccc",
                width: "100%",
                listStyle: "none",
                padding: "5px",
                marginTop: "5px",
                zIndex: 100,
                maxHeight: "250px",
                overflowY: "auto",
              }}
              className="HashTagSuggestionli"
            >
              {suggestions.map((item, index) => {
                const realIndex = mentionType === "Hashtag" ? index + 1 : index;
                const isActive = selectedIndex === realIndex;

                return (
                <li
                  key={index}
                  ref={(el) => (itemRefs.current[realIndex] = el)}
                  onMouseDown={(e) => {
                    e.preventDefault(); // Prevent editor blur
                    insertMention(
                      mentionType === "UserMention" ? item?.entityName : item?.hashTag,
                      mentionType === "UserMention" || item?.entityType === "CompanyMention" ? item?.userUid : null,
                      item?.entityType,
                    );
                    setShowSuggestions(false);
                  }}
                  className={`suggestion-item ${isActive ? "active" : ""}`}
                >
                  {mentionType === "UserMention" ? (
                    <>
                      <img src={item?.avatar || people.DefaultProfile} alt={item?.entityName} className="avatar" onError={handleProfileImageError} />
                      <span>{item?.entityName}</span>
                    </>
                  ) : (
                    <span>#{item?.hashTag}</span>
                  )}
                </li>
                );
              })}
            </ul>
          )}
          <span ref={emojiAnchorRef} className="wlj-emoji-anchor">
            <AddReactionSharpIcon
              className="material-symbols-sharp  me-2"
              onClick={handleEmojiClick}
              style={{ cursor: "pointer" }}
            />
          </span>
          <SendSharpIcon
            className="material-symbols-sharp"
            onClick={() => postData()}
            style={{
              cursor: isSubmittingComment ? "not-allowed" : "pointer",
              opacity: isSubmittingComment ? 0.5 : 1,
            }}
          />
        </div>
      </div>

      <PortalEmojiPicker
        show={showEmojiPicker}
        anchorRef={emojiAnchorRef}
        onClose={handleEmojiClose}
        onEmojiClick={(e) => {
          const newContent = content + e.emoji;
          setContent(newContent);
          setShowEmojiPicker(false);
          const updatedPostInputValue = updatePostInputValueWithDynamicValues(
            newContent,
            postDynamicValues
          );
          setPostInputValue(updatedPostInputValue);
        }}
      />

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />
      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default PostComment;
